document.addEventListener('DOMContentLoaded', function() {
  const collectionItems = document.querySelectorAll('.collection-switch__item');
  const collectionImages = document.querySelectorAll('.collection-switch__image-item');
  const collectionDescription = document.querySelector('.collection-switch__description');
  const collectionButtonLinks = document.querySelectorAll('.collection-switch__button-link');

  // 初期表示設定（最初のアイテムをアクティブにする）
  function initializeFirstItem() {
    const firstItem = document.querySelector('.collection-switch__item[data-active="true"]');
    if (firstItem && collectionItems.length > 0) {
      updateDisplay(firstItem);
    } else if (collectionItems.length > 0) {
      updateDisplay(collectionItems[0]);
    }
  }

  // 表示を更新する関数
  function updateDisplay(activeItem) {
    // すべてのアイテムからactiveクラスを削除
    collectionItems.forEach(item => {
      item.classList.remove('collection-switch__item--active');
      const itemDescription = item.querySelector('.collection-switch__item-description');
      if (itemDescription) {
        itemDescription.textContent = '';
      }
    });

    // クリックされたアイテムにactiveクラスを付与
    activeItem.classList.add('collection-switch__item--active');

    // 画像の表示/非表示を切り替え（フェード効果付き）
    const collectionId = activeItem.getAttribute('data-collection-id');
    
    // 現在表示中の画像を見つける
    let currentImage = null;
    collectionImages.forEach(img => {
      if (img.style.display === 'block' || (img.style.display === '' && window.getComputedStyle(img).display === 'block')) {
        currentImage = img;
      }
    });
    
    // 新しい表示対象の画像を見つける
    let newImage = null;
    collectionImages.forEach(img => {
      if (img.getAttribute('data-collection-id') === collectionId) {
        newImage = img;
      }
    });
    
    // 現在の画像をフェードアウト
    if (currentImage && currentImage !== newImage) {
      currentImage.style.opacity = '0';
      
      // フェードアウト完了後にdisplay: noneにする
      setTimeout(() => {
        currentImage.style.display = 'none';
        
        // 新しい画像をフェードイン
        if (newImage) {
          newImage.style.display = 'block';
          newImage.style.opacity = '0';
          
          // reflowを確実にするため、少し待ってからフェードイン
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              newImage.style.opacity = '1';
            });
          });
        }
      }, 300); // CSSのtransition時間（0.3s）と合わせる
    } else if (newImage && !currentImage) {
      // 初回表示の場合
      newImage.style.display = 'block';
      newImage.style.opacity = '0';
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          newImage.style.opacity = '1';
        });
      });
    }
    
    // 他の画像を非表示にする（まだ表示されていない場合）
    collectionImages.forEach(img => {
      if (img !== newImage && img !== currentImage) {
        img.style.display = 'none';
        img.style.opacity = '0';
      }
    });

    // 説明文を更新（アイテム内とコンテンツエリアの両方）
    const description = activeItem.getAttribute('data-collection-description');
    if (description) {
      // アイテム内の説明文（モバイル用）
      const itemDescription = activeItem.querySelector('.collection-switch__item-description');
      if (itemDescription) {
        itemDescription.innerHTML = description;
      }
      // コンテンツエリアの説明文（デスクトップ用）
      if (collectionDescription) {
        collectionDescription.innerHTML = description;
      }
    }

    // ボタンリンクを更新（すべてのボタンリンクを更新）
    const collectionUrl = activeItem.getAttribute('data-collection-url');
    if (collectionUrl && collectionButtonLinks.length > 0) {
      collectionButtonLinks.forEach(buttonLink => {
        buttonLink.href = collectionUrl;
      });
    }
  }

  // 各タイトルにクリックイベントを追加
  collectionItems.forEach(item => {
    const itemTitle = item.querySelector('.collection-switch__item-title');
    if (itemTitle) {
      itemTitle.addEventListener('click', function() {
        updateDisplay(item);
      });
    }
  });

  // 初期化
  initializeFirstItem();
});

